import React, { Component } from "react"
import ReactDOM from 'react-dom'
import styled from "styled-components"
import { Amplify } from 'aws-amplify';
import amplifyconfig from '../../../amplifyconfiguration.json';
import { post } from 'aws-amplify/api';
import { Form, Label, FormGroup, Input, FormFeedback, Row, Col } from "reactstrap"
import scrollToElement from "scroll-to-element"
import {
  validateRequired,
  validateEmail
} from 'utils/validations'
import { media } from "utils/Media"
import ContainerMax from "components/shared/ContainerMax"
import Button from "components/shared/Button"

Amplify.configure(amplifyconfig);

const Text = styled.div`
    h1, h2 {
      font-size: ${props => props.theme.font.h2.size};
      @media ${media.md} {
        font-size: ${props => props.theme.font.h1.size};
      }
    }
`

const FormWrap = styled.div`
  background-color: ${props => props.theme.colors.primary};
  padding: 2rem;
  margin: 2rem 0;
  border-radius: 5px; 

  .form-group {
    margin-bottom: 30px;
  }
`

const FormStyled = styled(Form)`
  max-width: 820px;
  margin: 0 auto;
  label {
    text-transform: uppercase;
    margin: 0;
    font-size: ${props => props.theme.font.size.sm};
  }

  .form-control {
    height: 50px;
    border-radius: 5px;
    border-color: ${props => props.theme.colors.grey2};
    
    &::placeholder {
      color: #ccc;
      font-style: italic;
      font-size: ${props => props.theme.font.size.lg};
    }
  }

  select {
    appearance: none;
  }

  textarea.form-control {
    min-height: 150px;
  }

  .invalid-feedback {
    color: red;
  }

  .form-control.is-invalid:focus {
    border-color: red;
    box-shadow: 0;
  }
`

const SubmitButton = styled(Button)`
  margin: 0 auto;
  padding-right: 3rem;
  padding-left: 3rem;
  background: white;
  color: ${props => props.theme.colors.primary};
  border: 2px solid white !important;
  text-transform: uppercase;
  font-family: ${props => props.theme.font.family.bold};
  border-radius: 5px;
  display: flex;
  align-items: center;

  &:hover {
    background: white;
    color: ${props => props.theme.colors.primary} !important;
  }
`

const Interest = styled.div`
  background: white;
  padding: 1rem 1rem .5rem 1rem;
  border-radius: 5px;
  font-size: ${props => props.theme.font.size.lg};
  color: ${props => props.theme.colors.primary};

  p, label {
    color: ${props => props.theme.colors.primary};
    font-size: ${props => props.theme.font.size.lg};
    width: 100%;
    text-transform: none;
  }

  input {
    margin-right: .5rem;
  }

  .interest-row {
    margin-bottom: .5rem;
  }
`

const Success = styled.span`
  padding: 2rem 0;
  p {
    color: ${props => props.theme.colors.white};
    font-size: ${props => props.theme.font.size.lg};
    font-family: ${props => props.theme.font.family.bold};
    margin: 1rem 0;
  }
`

const Loader = styled.div`
  width: 20px;
  height: 20px;
  border: 5px solid ${props => props.theme.colors.primary};
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  margin-left: 1rem;
  
  @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  } 
`

class FormPartnership extends Component {

  constructor(props) {
    super(props)

    this.state = {
      name: '',
      lastname: '',
      company: '',
      phone: '',
      email: '',
      interest: '',
      comments: '',
      send_to: 'russell.evans@img.com',
      googleVerified: '',
      sendingFormRequest: false,
      validate: {
        name: '',
        lastname: '',
        company: '',
        phone: '',
        email: '',
        interest: '',
        comments: '',
        googleVerified: '',
        googleVerifiedErrMsg: 'Google recaptcha is required'
      },
      required: {
        name: '',
        lastname: '',
        company: '',
        phone: '',
        email: '',
        interest: '',
        comments: '',
      },
      // displayCheckboxError: false,
      success: false
    }

    // Bind this to methods
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)

    // Bind this to validation methods
    this.validateRequired = validateRequired.bind(this);
    this.validateEmail = validateEmail.bind(this);

    // Create form ref
    this.form = React.createRef();
    this.successMessage = React.createRef();
  }

  handleChange = (e) => {
    const target = e.target
    const name = target.name
    const value = target.value
    
    let required = this.state.required
    
    if (required.hasOwnProperty(name)) {
      required[name] = value
    }
    
    // Update value in state
    this.setState({
      required,
      [name]: value,
    });
  }

  handleCheckboxChange = (e) => {
    let required = this.state.required
    const target = e.target
    const name = target.name
    const value = target.value

    this.setState((prevState) => {
      const selectedValues = prevState[name];

      // Toggle the presence of the value in the array
      const updatedValues = selectedValues.includes(value)
        ? selectedValues.filter((val) => val !== value)
        : [...selectedValues, value];

      if (required.hasOwnProperty(name)) {
        required[name] = value
      }

      return {
        required,
        [e.target.name]: updatedValues,
      };
    });
  };

  async handleSubmit(e) {
    e.preventDefault();
    
    //disable the button so we can't send multiple requests
    this.setState({sendingFormRequest: true});
    
    // Create form data ready for api wrapper call
    let formData = {};
    for (let key in this.state) {
      if (typeof this.state[key] === 'object' && this.state[key].constructor === Object) {
        for (let k in this.state[key]) {
          formData[key + '[' + k + ']'] = this.state[key][k];
          //formData.append(key + '[' + k + ']', this.state[key][k])
        }
      } else {
        formData[key] = this.state[key];
        //formData.append(key, this.state[key]);
      }
    }
    
    let {validate} = this.state
    let errors = false
    
    for (let key in this.state.validate) {
      if (this.state.required[key] === "" && key !== "googleVerified" && key !== "googleVerifiedErrMsg") {
        validate[key] = 'has-danger'
        // if (key === "interest") this.setState({displayCheckboxError: true})
        errors = true
      }
      
      this.setState({validate});
    }
    
    // return if errors
    if (errors) {

      this.setState({
        sendingFormRequest: false,
      });

      return
    }
  
    try {
      const restOperation = post({
        apiName: 'chevronPartnershipAPI',
        path: '/form',
        options: {
          body: formData
        }
      });
  
      const { body } = await restOperation.response;
      const response = await body.json();
  
      console.log('POST call succeeded');
      console.log(response);

      // this.setState({
      //   sendingFormRequest: false,
      //   success: true
      // });

      const domNode = ReactDOM.findDOMNode(this.successMessage.current)

      const header = document.getElementById('siteHeader')
      let headerHeight = 0
      if (header) {
        headerHeight = header.offsetHeight
      }

      setTimeout(() => {
        scrollToElement(domNode, {
          offset: - (headerHeight + 40),
          duration: 500
        });
      }, 1000);

      this.setState({
        name: '',
        lastname: '',
        company: '',
        phone: '',
        email: '',
        interest: '',
        comments: '',
        send_to: 'russell.evans@img.com',
        // send_to: 's.richards@dewynters.com',
        googleVerified: '',
        sendingFormRequest: false,
        validate: {
          name: '',
          lastname: '',
          company: '',
          phone: '',
          email: '',
          interest: '',
          comments: '',
          googleVerified: '',
          googleVerifiedErrMsg: 'Google recaptcha is required'
        },
        required: {
          name: '',
          lastname: '',
          company: '',
          phone: '',
          email: '',
          interest: '',
          comments: '',
        },
        // displayCheckboxError: false,
        success: true
      })
      this.form.current.reset()

    } catch (e) {
      console.log('POST call failed: ', e);
      this.setState({sendingFormRequest: false});
    }
  }

  render() {
    const { block } = this.props
    const { text, successMessage } = block

    return (
      <ContainerMax 
        maxWidth="1360"
        className="py-4"
      >
        <Text dangerouslySetInnerHTML={{ __html: text }} />

        <FormWrap>
          <FormStyled onSubmit={(e) => this.state.sendingFormRequest ? e.preventDefault() : this.handleSubmit(e)} noValidate ref={this.form}>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="name" className="sr-only">First name<Text as="span" red>*</Text></Label>
                  <Input
                    type="text"
                    name="name"
                    id="name"
                    placeholder="First name"
                    value={this.state.name}
                    valid={this.state.validate.name === 'has-success'}
                    invalid={this.state.validate.name === 'has-danger'}
                    onChange={e => {
                      this.handleChange(e)
                      this.validateRequired(e)
                    }}
                  />
                  <FormFeedback>
                    Your name is required
                  </FormFeedback>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="lastname" className="sr-only">Last name<Text as="span" red>*</Text></Label>
                  <Input
                    type="text"
                    name="lastname"
                    id="lastname"
                    placeholder="Last name"
                    value={this.state.lastname}
                    valid={this.state.validate.lastname === 'has-success'}
                    invalid={this.state.validate.lastname === 'has-danger'}
                    onChange={e => {
                      this.handleChange(e)
                      this.validateRequired(e)
                    }}
                  />
                  <FormFeedback>
                    Your last name is required
                  </FormFeedback>
                </FormGroup>
              </Col>
            </Row>
            <FormGroup>
              <Label for="company" className="sr-only">Company<Text as="span" red>*</Text></Label>
              <Input
                type="text"
                name="company"
                id="company"
                placeholder="Company"
                value={this.state.company}
                valid={this.state.validate.company === 'has-success'}
                invalid={this.state.validate.company === 'has-danger'}
                onChange={e => {
                  this.handleChange(e)
                  this.validateRequired(e)
                }}
              />
              <FormFeedback>
                Company name is required
              </FormFeedback>
            </FormGroup>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="name" className="sr-only">Phone number<Text as="span" red>*</Text></Label>
                  <Input
                    type="text"
                    name="phone"
                    id="phone"
                    placeholder="Phone number"
                    value={this.state.phone}
                    valid={this.state.validate.phone === 'has-success'}
                    invalid={this.state.validate.phone === 'has-danger'}
                    onChange={e => {
                      this.handleChange(e)
                      this.validateRequired(e)
                    }}
                  />
                  <FormFeedback>
                    Youe phone number is required
                  </FormFeedback>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="email" className="sr-only">Email<Text as="span" red>*</Text></Label>
                  <Input
                    type="text"
                    name="email"
                    id="email"
                    placeholder="Email"
                    value={this.state.email}
                    valid={this.state.validate.email === 'has-success'}
                    invalid={this.state.validate.email === 'has-danger'}
                    onChange={e => {
                      this.handleChange(e)
                      this.validateRequired(e)
                      this.validateEmail(e)
                    }}
                  />
                  <FormFeedback>
                    Your email is required
                  </FormFeedback>
                </FormGroup>
              </Col>
            </Row>
            <FormGroup>
              <Interest>
                <p><strong>Interest</strong></p>
  
                <Row>
                  <Col md={6}>
                    <label className="interest-row">
                      <input 
                        type="checkbox" 
                        name="interest" 
                        value="Official Pro-Am" 
                        checked={this.state.interest.includes("Official Pro-Am")}
                        onChange={(e) => this.handleCheckboxChange(e)}
                      />Official Pro-Am
                    </label>
                    <label className="interest-row">
                      <input 
                        type="checkbox"
                        name="interest" 
                        value="Jr. Legacy Pro-Am" 
                        checked={this.state.interest.includes("Jr. Legacy Pro-Am")}
                        onChange={(e) => this.handleCheckboxChange(e)}
                      />Jr. Legacy Pro-Am
                    </label>
                    <label className="interest-row">
                      <input 
                        type="checkbox" 
                        name="interest" 
                        value="Dinah's Place by 18th Green"
                        checked={this.state.interest.includes("Dinah's Place by 18th Green")}
                        onChange={(e) => this.handleCheckboxChange(e)}
                      />Dinah's Place by 18th Green
                    </label>
                  </Col>
                  <Col md={6}>
                    <label className="interest-row">
                      <input 
                        type="checkbox" 
                        name="interest" 
                        value="The Cabanas on 17th Green" 
                        checked={this.state.interest.includes("The Cabanas on 17th Green")}
                        onChange={(e) => this.handleCheckboxChange(e)}
                      />The Cabanas on 17th Green
                    </label>
                    <label className="interest-row">
                      <input 
                        type="checkbox" 
                        name="interest" 
                        value="The Club Suites on 18th Green" 
                        checked={this.state.interest.includes("The Club Suites on 18th Green")}
                        onChange={(e) => this.handleCheckboxChange(e)}
                      />The Club Suites on 18th Green
                    </label>
                    <label className="interest-row">
                      <input 
                        type="checkbox" 
                        name="interest"
                        value="Honorary Observer"
                        checked={this.state.interest.includes("Honorary Observer")}
                        onChange={(e) => this.handleCheckboxChange(e)}
                      />Honorary Observer
                    </label>
                  </Col>
                </Row>
              </Interest>
              {/* {this.state.displayCheckboxError && (
                <p className="invalid-feedback d-block">Please select at least one interest</p>
              )} */}
            </FormGroup>
            <FormGroup>
              <Label for="comments" className="sr-only">Questions or comments</Label>
              <Input
                type="textarea"
                name="comments"
                id="comments"
                value={this.state.comments}
                placeholder="Questions or comments"
                onChange={e => {
                  this.handleChange(e)
                  this.validateRequired(e)
                }}
                valid={this.state.validate.comments === 'has-success'}
                invalid={this.state.validate.comments === 'has-danger'}
              />
              <FormFeedback>
                Questions or comments are required
              </FormFeedback>
            </FormGroup>
  
            <p className="text-white">All fields are required</p>
  
            <div className="d-flex justify-content-center align-items-center">
              <div>
                <SubmitButton
                  as="button"
                  color="primary"
                  className="my-3"
                  type="submit"
                >
                  Submit
                  {this.state.sendingFormRequest && (
                    <Loader></Loader>
                  )}
                </SubmitButton>
              </div>
            </div>
                
            {this.state.success && (
              <Success dangerouslySetInnerHTML={{__html: successMessage}} ref={this.successMessage} />
            )}
          </FormStyled>
        </FormWrap>
  
       
      </ContainerMax>
    )
  }
}

export default FormPartnership